import { useAppDispatch, useEffectOnce } from 'hooks'
import { ReactNode } from 'react'
import { getQueryParams } from 'utils'
import { InitData } from './components/InitData/InitData'
import { InitWidgetType } from './components/InitWidgetType/InitWidgetType'
import { DEFAULT_TITLE_FONT_SIZE } from './Init.model'
import {
  setBackgroundImage,
  setSeeAllScoresButton,
  setWidgetTitleFontSize,
} from './state/Init.reducer'

export function InitProvider({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch()
  const { titleFontSize, seeAllScoresButton, backgroundImage } = getQueryParams()

  useEffectOnce(() => {
    if (titleFontSize) {
      let fontSize = parseInt(titleFontSize, 10)
      if (isNaN(fontSize)) {
        fontSize = DEFAULT_TITLE_FONT_SIZE
      }
      dispatch(setWidgetTitleFontSize(fontSize))
    }

    if (seeAllScoresButton !== undefined) {
      dispatch(setSeeAllScoresButton(seeAllScoresButton === 'true'))
    }

    if (backgroundImage) {
      dispatch(setBackgroundImage(backgroundImage))
    }
  })

  return (
    <InitWidgetType>
      <InitData>{children}</InitData>
    </InitWidgetType>
  )
}
